import type { Nullable } from '@iheartjane/types';
import { useQuery } from '@tanstack/react-query';

import type { QueryBody } from '@jane/shared/data-access';
import { janeApi, safeParseAsync } from '@jane/shared/data-access';
import type { Kiosk } from '@jane/shared/types';

import { zKiosk } from './kiosk.types';

type KioskQueryBody = QueryBody<Kiosk | null, unknown, Kiosk | null>;
type GetKioskReturnType = {
  kiosk: Kiosk;
};

const getKiosk = async (kioskId: number) => {
  const url = `/kiosks/${kioskId}`;

  const response = await janeApi.get<GetKioskReturnType>(url);

  return await safeParseAsync(zKiosk, response.kiosk, 'getKiosk');
};

export function getKioskQueryBody(
  kioskId: Nullable<number>,
  options = {}
): KioskQueryBody {
  return {
    queryFn: () => (kioskId ? getKiosk(kioskId) : null),
    queryKey: ['kiosk', kioskId],
    ...options,
  };
}

interface UseGetKioskArgs {
  initialData?: Nullable<Kiosk>;
  kioskId: Nullable<number>;
}
export const useGetKiosk = ({ initialData, kioskId }: UseGetKioskArgs) => {
  return useQuery(getKioskQueryBody(kioskId, { initialData }));
};
